let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4zd0L")).then(() => parcelRequire('9CXkG'));